﻿module.exports = {
    bindings: {
        isLarge: '<',
        item: '<'
    },
    controller: subchapterNotesButton,
    templateUrl: 'texts/components/subchapter-notes-button.html'
};

subchapterNotesButton.$inject = ['annotationsModal'];

function subchapterNotesButton(annotationsModal) {

    var vm = {
        showAnnotation: showAnnotation
    };

    function showAnnotation() {
        annotationsModal.show(null, null, vm.item.subchapter);
    }


    return vm;

}